const parseRulebookMeterChips = (raw) => {
    let parsed = raw;
    if (typeof raw === "string") {
        try {
            parsed = JSON.parse(raw);
        }
        catch {
            return [];
        }
    }
    if (!Array.isArray(parsed)) {
        return [];
    }
    return parsed.flatMap((entry) => {
        if (typeof entry !== "object" || entry === null || !("label" in entry) || !("type" in entry)) {
            return [];
        }
        const chip = entry;
        if (typeof chip.label !== "string" || typeof chip.type !== "string") {
            return [];
        }
        return [
            {
                label: chip.label,
                type: chip.type,
                ...(typeof chip.icon === "string" ? { icon: chip.icon } : {}),
                ...(typeof chip.color === "string" ? { color: chip.color } : {}),
            },
        ];
    });
};
export default parseRulebookMeterChips;
